import React from 'react';
import { FixedGrid, H2, StyledIconButton } from '../../../ui';
import styled from '@emotion/styled';
import {
	CheckpointQueue,
	StyledCheckpointQueue,
	StyledCheckpointQueueLink,
} from './checkpoint-queue';
import { LastUpdated } from './LastUpdated';
import { AccessTypeFilter } from './access-type-filter';
import Refresh from '../../../../assets/refresh.svg';
import { IQueueList } from '../domain/models/IQueueList';
import { ITranslationFunction } from '../../shared/i18n/translate';
import { ICheckpointQueue } from '../domain/models/ICheckpointQueue';
import { useTranslation } from '../../shared/i18n/translate/useTranslation';

interface ICheckpointQueuesProps {
	queueLists: IQueueList[];
	refresh: () => void;
}

const CheckpointList = ({
	queueList: { checkpointQueues, titleTranslationKey },
	t,
}: {
	queueList: IQueueList;
	t: ITranslationFunction;
}) =>
	!checkpointQueues.length ? null : (
		<>
			<H2 styling="h3">{t(titleTranslationKey)}</H2>
			<StyledFixedGrid
				role="list"
				columns={[2, { mobileXL: 1 }]}
				itemSelector={[StyledCheckpointQueue, StyledCheckpointQueueLink]}
			>
				{checkpointQueues.map((checkpointQueue) => (
					<CheckpointQueue
						key={checkpointQueue.id}
						checkpointQueue={checkpointQueue}
					/>
				))}
			</StyledFixedGrid>
		</>
	);

export const CheckpointQueues = ({
	queueLists,
	refresh,
}: ICheckpointQueuesProps) => {
	const { t } = useTranslation();
	return (
		<>
			<AccessTypeFilter />
			<p>
				<LastUpdated
					checkpointQueues={queueLists.reduce(
						(red, { checkpointQueues }) => red.concat(checkpointQueues),
						[] as ICheckpointQueue[],
					)}
				/>
				<StyledRefreshIconButton onClick={refresh}>
					{t('security_checkpoint_refresh_checkpoints')}
					<Refresh />
				</StyledRefreshIconButton>
			</p>
			{queueLists.map((queueList) => (
				<CheckpointList
					key={queueList.accessType}
					queueList={queueList}
					t={t}
				/>
			))}
		</>
	);
};

const StyledFixedGrid = styled(FixedGrid)`
	margin-bottom: 40px;
	&:last-child {
		margin-bottom: 0px;
	}
`;

const StyledRefreshIconButton = styled(StyledIconButton)`
	margin-left: 16px;
	cursor: pointer;
	font-family: inherit;

	svg {
		margin-bottom: 2px;
	}
`;
